import { render, staticRenderFns } from "./ClearAuthenticationToken.vue?vue&type=template&id=3dc94674&scoped=true&"
import script from "./ClearAuthenticationToken.vue?vue&type=script&lang=js&"
export * from "./ClearAuthenticationToken.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc94674",
  null
  
)

export default component.exports